import { render, staticRenderFns } from "./FeesHistory.vue?vue&type=template&id=17c09fba&scoped=true&"
import script from "./FeesHistory.vue?vue&type=script&lang=js&"
export * from "./FeesHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c09fba",
  null
  
)

export default component.exports